var map = {
	"./dimensions.png": "2722",
	"./temp-3-header.png": "87c7",
	"./template-old.png": "cfeb",
	"./template.png": "cfdf",
	"./template2-old.png": "da60",
	"./template2.png": "8608",
	"./template3-old.png": "9ed4",
	"./template3.png": "f52a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bfa5";